module.exports = __webpack_public_path__ + "img/74.c5585916.jpg";